import { requireAll } from '@/js/utils/functions';

// load all js files, but exclude those in partials
requireAll(require.context('./', true, /^(?!.*\/partials\/).*.js$/));

// personal communication id, this will be sent with the init message
let myPersonalCommunicationId = '';

// Listen for messages sent by the parent page
window.addEventListener('message', (event) => {
  const { action } = event.data;
  if (action === 'init') {
    // on init, assign the unique personal communication id sent from the parent page
    myPersonalCommunicationId = event.data.id;

    // on init sent the initial height of the iframe
    window.parent.postMessage(
      {
        action: 'resize',
        id: myPersonalCommunicationId,
        height: document.documentElement.offsetHeight,
      },
      '*',
    );
  }
});

// Add a resize event listener to listen for resize changes in your iframe.
// When a resize event, sent a message to the parent page to update the height.
window.addEventListener('resize', () => {
  window.parent.postMessage(
    {
      action: 'resize',
      id: myPersonalCommunicationId,
      height: document.documentElement.offsetHeight,
    },
    '*',
  );
});
